<!-- Start Breadcrumb
============================================= -->
<div class="breadcrumb-area bg-cover shadow theme-hard text-center text-light" style="background-image: url(assets/img/banner/8.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1>About Us</h1>
        <ul class="breadcrumb">
          <li><a routerLink="/"><i class="fas fa-home"></i> Home</a></li>
          <li>About</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- End Breadcrumb -->
<!-- Start About
============================================= -->
<div class="about-style-one-area default-padding">
  <div class="shape-animated-left">
    <img src="assets/img/shape/3.png" alt="Image Not Found">
    <img src="assets/img/shape/4.png" alt="Image Not Found">
  </div>
  <div class="container">
    <div class="row align-center">
      <div class="about-style-one col-xl-5 col-lg-6">
        <div class="about-thumb">
          <img class="wow fadeInRight" src="/assets/img/about/1.jpg" alt="Image Not Found">
          <div class="about-card wow fadeInUp" data-wow-delay="500ms">
            <ul>
              <li>
                <div class="icon">
                  <i class="flaticon-license"></i>
                </div>
                <div class="fun-fact">
                  <div class="counter">
                    <div class="timer" data-to="36" data-speed="2000">17</div>
                    <div class="operator">+</div>
                  </div>
                  <span class="medium">Years of experience</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <i class="flaticon-global"></i>
                </div>
                <div class="fun-fact">
                  <div class="counter">
                    <div class="timer" data-to="120" data-speed="2000">100</div>
                    <div class="operator">K</div>
                  </div>
                  <span class="medium">Users Powered Across Platforms</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="thumb-shape-bottom wow fadeInDown" data-wow-delay="300ms">
            <img src="assets/img/illustration/4.png" alt="Image Not Found">
          </div>
        </div>
      </div>
      <div class="about-style-one col-xl-6 col-lg-5  offset-xl-1 offset-lg-1">
        <h4 class="sub-title">About Our Company</h4>
        <h2 class="title split-text mb-25">Engineering Secure, Intelligent & Connected Digital Systems</h2>
        <div class="wow fadeInUp" data-wow-delay="200ms">
          <p>
            At Novarix Tech, we design and build secure, scalable, and future-ready technology platforms that power modern enterprises. From distributed cloud architectures and encrypted data systems to IoT-integrated smart solutions, we combine deep engineering expertise with real-world execution.
          </p>
          <p>
            Our focus is on building systems that are not only high-performing but also resilient, secure, and designed for long-term growth.
          </p>
          <div class="accordion mt-30" id="faqAccordion">
            <div class="accordion-single">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Secure Cloud & Distributed Systems
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  <p>
                    We architect encrypted, high-availability cloud platforms with advanced authentication models, optimized task scheduling, secure data transfer, and scalable storage systems built for modern digital demands.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-single">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  IoT & Smart Device Integration
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  <p>
                    End-to-end hardware-to-cloud solutions including biometric systems, access control platforms, real-time synchronization, and secure device communication frameworks.
                  </p>
                </div>
              </div>
            </div>
            <div class="accordion-single">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Enterprise Application Modernization
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  <p>
                    Modern full-stack development using .NET, Next.js, Azure, PostgreSQL, and cloud-native services to transform legacy systems into scalable digital platforms.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End About -->
<!-- Start Process
============================================= -->
<div class="process-style-one-area bg-gray text-center default-padding bg-cover" style="background-image: url(assets/img/shape/banner.jpg);">
  <div class="large-shape">
    <img src="assets/img/shape/11.png" alt="Shape">
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="site-heading text-center">
          <h4 class="sub-title">Our Process</h4>
          <h2 class="title split-text">How We Design & Deliver <br> Secure Digital Solutions</h2>
          <div class="devider"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <!-- Single Item -->
      <div class="col-lg-4">
        <div class="process-style-one active wow fadeInUp">
          <div class="thumb">
            <img src="/assets/img/about/3.jpg" alt="Thumb">
            <span>01</span>
          </div>
          <h4>Architect with Clarity</h4>
          <p>
            Define, Design & Secure the Foundation
          </p>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-lg-4">
        <div class="process-style-one wow fadeInUp" data-wow-delay="150ms">
          <div class="thumb">
            <img src="/assets/img/about/6.jpg" alt="Thumb">
            <span>02</span>
          </div>
          <h4>Build with Precision</h4>
          <p>
            Engineer Scalable & Intelligent Systems
          </p>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-lg-4">
        <div class="process-style-one wow fadeInUp" data-wow-delay="300ms">
          <div class="thumb">
            <img src="assets/img/about/5.jpg" alt="Thumb">
            <span>03</span>
          </div>
          <h4>Optimize & Scale</h4>
          <p>
            Deploy, Monitor & Continuously Improve
          </p>
        </div>
      </div>
      <!-- End Single Item -->
    </div>
  </div>
</div>
<!-- End Process -->
<!-- Start Partner Area
============================================= -->
<div class="partner-style-one-area default-padding">
  <div class="container">
    <div class="row align-center">
      <div class="col-lg-5">
        <div class="partner-map wow fadeInUp" style="background-image: url(assets/img/shape/map.png);">
          <h2 class="mask-text" style="background-image: url(/assets/img/banner/6.jpg);">80</h2>
          <h4>Partners in world wide</h4>
        </div>
      </div>
      <div class="col-lg-6 offset-lg-1">
        <div class="partner-items wow fadeInUp" data-wow-delay="150ms">
          <ul>
            <li><img src="/assets/img/logo/1.png" alt="Image Not FOund"></li>
            <li><img src="/assets/img/logo/2.png" alt="Image Not FOund"></li>
            <li><img src="/assets/img/logo/7.png" alt="Image Not FOund"></li>
            <li><img src="/assets/img/logo/4.png" alt="Image Not FOund"></li>
            <li><img src="/assets/img/logo/5.png" alt="Image Not FOund"></li>
            <li><img src="/assets/img/logo/6.png" alt="Image Not FOund"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Partner Area -->
<!-- Start Team
============================================= -->
<div class="team-style-onea-rea default-padding-top pb-70 pb-xs-0 bg-gray bg-cover" style="background-image: url(assets/img/shape/banner.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="site-heading text-center">
          <h4 class="sub-title">Leadership & Engineering</h4>
          <h2 class="title split-text">Meet Our Core Technical & Advisory Team</h2>
          <div class="devider"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <!-- Single Item -->
      <div class="col-xl-3 col-md-6">
        <div class="team-style-one active wow fadeInUp">
          <div class="thumb">
            <img src="assets/img/team/1.jpg" alt="Executive Leadership">
            <div class="social">
              <ul>
                <li class="linkedin">
                  <a routerLink="/organizational-chart">
                    <i class="fas fa-sitemap"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="info">
            <span>Executive Leadership & Strategy</span>
            <h4><a routerLink="/organizational-chart">Chief Executive & Founder</a></h4>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-xl-3 col-md-6">
        <div class="team-style-one wow fadeInUp" data-wow-delay="100ms">
          <div class="thumb">
            <img src="assets/img/team/2.jpg" alt="Cloud Architecture">
            <div class="social">
              <ul>
                <li class="linkedin">
                  <a routerLink="/organizational-chart">
                    <i class="fas fa-sitemap"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="info">
            <span>Cloud & High-Availability</span>
            <h4><a routerLink="/organizational-chart">Principal Cloud Architect</a></h4>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-xl-3 col-md-6">
        <div class="team-style-one wow fadeInUp" data-wow-delay="200ms">
          <div class="thumb">
            <img src="assets/img/team/3.jpg" alt="IoT & Hardware">
            <div class="social">
              <ul>
                <li class="linkedin">
                  <a routerLink="/organizational-chart">
                    <i class="fas fa-sitemap"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="info">
            <span>IoT & Biometric Hardware</span>
            <h4><a routerLink="/organizational-chart">Lead Embedded Systems Engineer</a></h4>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
      <!-- Single Item -->
      <div class="col-xl-3 col-md-6">
        <div class="team-style-one wow fadeInUp" data-wow-delay="300ms">
          <div class="thumb">
            <img src="assets/img/team/4.jpg" alt="Academic Governance">
            <div class="social">
              <ul>
                <li class="linkedin">
                  <a routerLink="/mentor">
                    <i class="fas fa-user-tie"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="info">
            <span>Higher Education & Advisory</span>
            <h4><a routerLink="/mentor">Institutional Program Advisor</a></h4>
          </div>
        </div>
      </div>
      <!-- End Single Item -->
    </div>
  </div>
</div>
<!-- End Team Area -->
<!-- Start Testimonials
============================================= -->
<div class="testimonial-style-one-area default-padding">
  <div class="container">
    <div class="row align-center">

      <div class="col-lg-4">
        <div class="testimonial-thumb wow fadeInUp">
          <div class="thumb-item">
            <img src="assets/img/illustration/5.png" alt="illustration">
            <div class="mini-shape">
              <img src="assets/img/shape/19.png" alt="illustration">
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 offset-lg-1">
        <div class="testimonial-carousel swiper wow fadeInUp" data-wow-delay="150ms">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Single item -->
            <div class="swiper-slide">
              <div class="testimonial-style-one">

                <div class="item">
                  <div class="content">
                    <div class="rating">
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                    </div>
                    <h2>Transformative University Automation</h2>
                    <p>
                      “Novarix Technologies delivered a mission-critical automated valuation and examination processing platform for JNTUA. The solution streamlined student result workflows across all affiliated colleges with exceptional data integrity, high performance, and robust security.”
                    </p>
                  </div>
                  <div class="provider">
                    <i class="flaticon-quote"></i>
                    <div class="info">
                      <h4>Directorate of Evaluation</h4>
                      <span>JNTU Anantapur, Andhra Pradesh</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Single item -->
            <!-- Single item -->
            <div class="swiper-slide">
              <div class="testimonial-style-one">
                <div class="item">
                  <div class="content">
                    <div class="rating">
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                      <i class="fas fa-star"></i>
                    </div>
                    <h2>Seamless Campus Lifecycle Management</h2>
                    <p>
                      “Implementing the unified institutional automation suite transformed our student fee reconciliation, attendance tracking, and administrative workflows across campuses. Novarix's engineering excellence and dedicated support made all the difference.”
                    </p>
                  </div>
                  <div class="provider">
                    <i class="flaticon-quote"></i>
                    <div class="info">
                      <h4>Institutional Leadership</h4>
                      <span>Sri Balaji Educational Society (SBES)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Single item -->
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
<!-- End Testimonails  -->
